import api from "../../../services/api";

export type FrequencyBucket = {
  customers: number;
  percentage?: number;
  status: string;
};

export type EcommPurchaseFrequencyResponse = {
  purchase_frequency: {
    one_time_buyers: FrequencyBucket;
    two_three_times_buyers: FrequencyBucket;
    four_six_times_buyers: FrequencyBucket;
    seven_twelve_times_buyers: FrequencyBucket;
    thirteen_plus_times_buyers: FrequencyBucket;
    repeat_customers: FrequencyBucket;
    power_users: FrequencyBucket;
  };
};

export async function fetchEcommPurchaseFrequency(): Promise<EcommPurchaseFrequencyResponse> {
  const response = await api.get<EcommPurchaseFrequencyResponse>("/api/shopify/customer_insights/purchase_frequency");
  return response.data;
}
